/**
 * Determines if a game has ended — either admin explicitly completed it,
 * or the endDate has passed.
 */
export function isGameOver(game: { status: string; endDate?: string | Date }): boolean {
    if (game.status === 'completed') return true;
    if (game.endDate) {
        const endOfDay = new Date(game.endDate);
        endOfDay.setUTCHours(23, 59, 59, 999);
        if (endOfDay < new Date()) return true;
    }
    return false;
}

/**
 * Returns the number of calendar days remaining until the game ends.
 * - Returns 0 if the end date is today.
 * - Returns a positive number for future end dates.
 * - Returns a negative number if already past (or null if no endDate).
 */
export function getDaysRemaining(endDate?: string | Date): number | null {
    if (!endDate) return null;
    const end = new Date(endDate);
    const today = new Date();
    // Normalise both to midnight UTC-local by stripping time
    const endMidnight = new Date(end.getFullYear(), end.getMonth(), end.getDate());
    const todayMidnight = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const diffMs = endMidnight.getTime() - todayMidnight.getTime();
    return Math.round(diffMs / (1000 * 60 * 60 * 24));
}
